import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import { API_BASE_URL } from '..';
import {
  CreateUserRequest,
  UpdateUserRequest,
  User,
  UserChangePasswordRequest,
  UserDetailReduced,
  UserPasswordRecovery,
  UserReduced,
} from './Users.types';
import { publicInstance } from '@/api/axiosInstance';

const CONTROLLER_URL = `${API_BASE_URL}/users`;

export async function listUsers(params?: PageRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, params)) as unknown;

  return result as PageResult<User>;
}

export async function listUsersReduced(params?: PageRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/matrix/reduced`,
    params,
  )) as unknown;

  return result as PageResult<UserReduced>;
}

export async function getUser(id?: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as User;
}

export async function getUserReduced(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/reduced`,
    null,
  )) as unknown;

  return result as UserDetailReduced;
}

export async function createUser(obj: CreateUserRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as User;
}

export async function updateUser(obj: UpdateUserRequest) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as User;
}

export async function changePassword(obj: UserChangePasswordRequest) {
  const params = new URLSearchParams(Object(obj));

  const result = (await api.patch(
    `${CONTROLLER_URL}/password?${params}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function userPasswordRecovery(data: UserPasswordRecovery) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/password-recovery`,
    data,
    null,
  )) as unknown;

  return result as User;
}

export async function userValidateCode(code?: string) {
  const result = (await publicInstance.post(
    `${CONTROLLER_URL}/validate/${code}`,
  )) as unknown;

  return result as void;
}

export async function userTokenPl24() {
  const result = (await api.get(`${CONTROLLER_URL}/token-pl24`, {})) as unknown;

  return result as { token: string };
}

export async function activeInactiveUser(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/activate-inactivate`,
    {},
    null,
  )) as unknown;

  return result as User;
}
